var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtHealthInsurance2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 70,
    viewBox: "0 0 74 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7EB736",
    d: "m60.128 20.91.07-.546-5.436-.712.203-7.54-.55-.017-.218 8.039z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.09 2.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.282 63.665a7.785 7.785 0 0 1-2.896-6.058V42.73h-.904v14.25c0 2.838 1.53 5.32 3.8 6.684z",
    fill: "#25ADE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.905 30.353V56.98c0 5.312-4.32 9.634-9.629 9.634a9.563 9.563 0 0 1-4.988-1.396 9.573 9.573 0 0 0 5.89 2.022c5.31 0 9.63-4.322 9.63-9.634V30.353h-.904.001z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.905 56.981V30.353h-.931v27.254c0 4.3-3.497 7.798-7.794 7.798a7.75 7.75 0 0 1-4.898-1.74c-2.27-1.364-3.8-3.846-3.8-6.684v-14.25h-.931v14.876a9.622 9.622 0 0 0 3.737 7.612 9.563 9.563 0 0 0 4.988 1.396c5.31 0 9.63-4.322 9.63-9.634z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.022 31.926c-7.657 0-13.886-6.232-13.886-13.893V4.849A4.198 4.198 0 0 1 13.328.655h3.669V2.75h-3.669a2.099 2.099 0 0 0-2.095 2.097V18.03c0 6.505 5.288 11.795 11.79 11.795 6.5 0 11.789-5.29 11.789-11.795V4.849a2.099 2.099 0 0 0-2.095-2.096H29.18V.656h3.537a4.198 4.198 0 0 1 4.192 4.195v13.183c0 7.661-6.23 13.894-13.887 13.894v-.002z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.098 4.898v12.716c0 7.093 5.796 12.862 12.92 12.862 7.123 0 12.92-5.77 12.92-12.862V4.898c0-2.14-1.751-3.127-3.9-3.127h-2.856v.98h3.536c1.156 0 2.096.94 2.096 2.097V18.03c0 6.505-5.289 11.795-11.79 11.795-6.501 0-11.79-5.29-11.79-11.795V4.849c0-1.156.94-2.096 2.096-2.096h3.668v-.98H14c-2.15 0-3.9.985-3.9 3.127v-.002z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.296 10.1c-.648.045-1.159.49-1.159 1.039v5.845c0 .552.517 1 1.173 1.04a9.548 9.548 0 0 1-.012-.41v-7.513l-.002-.001z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.187 18.033c.597 0 1.083-.47 1.083-1.05V11.14c0-.578-.484-1.05-1.083-1.05-.03 0-.06.007-.089.009v7.513c0 .138.007.273.01.41.027.002.052.008.08.008v.004z",
    fill: "#1199CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.994 22.828c.269.727.597 1.429.985 2.102a1.052 1.052 0 0 0 1.51.347c.037-.025.068-.054.099-.083a12.835 12.835 0 0 1-1.905-3.747c-.588.17-.902.805-.69 1.38v.001z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.088 23.902a10.71 10.71 0 0 1-1.129-1.82c-.004-.011-.013-.02-.02-.03.317.66.714 1.291 1.173 1.889-.009-.013-.013-.026-.024-.038v-.001z",
    fill: "#DDECDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.824 23.94c-.349-.6-.647-1.23-.886-1.889a1.04 1.04 0 0 0-1.244-.606c-.003 0-.006.004-.01.004a12.796 12.796 0 0 0 1.905 3.746 1.04 1.04 0 0 0 .236-1.256h-.001z",
    fill: "#1199CD"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1E2969",
    x: 13.591,
    width: 4.715,
    height: 3.146,
    rx: 1.018
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#13687C",
    x: 26.953,
    width: 4.715,
    height: 3.146,
    rx: 1.018
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.735 1.953h-1.572c-.643 0-1.196-.415-1.439-1.007a1.732 1.732 0 0 0-.132.665c0 .918.707 1.669 1.571 1.669h1.572c.864 0 1.57-.75 1.57-1.67 0-.235-.046-.46-.131-.664-.243.59-.798 1.007-1.44 1.007z",
    fill: "#002654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.097 1.953h-1.571c-.643 0-1.197-.415-1.44-1.007a1.732 1.732 0 0 0-.131.665c0 .918.706 1.669 1.572 1.669H30.1c.864 0 1.572-.75 1.572-1.67 0-.235-.049-.46-.132-.664-.242.59-.797 1.007-1.439 1.007h-.003z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#25ADE1",
    transform: "rotate(-77.33 5.402 43.056)",
    cx: 5.402,
    cy: 43.056,
    rx: 4.522,
    ry: 4.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C81E6",
    transform: "rotate(-77.33 5.403 42.401)",
    cx: 5.403,
    cy: 42.401,
    rx: 4.522,
    ry: 4.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#999",
    transform: "rotate(-77.3 5.407 42.409)",
    cx: 5.407,
    cy: 42.409,
    rx: 2.215,
    ry: 2.214
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.081 41.223a.412.412 0 0 1-.25-.579c.392-.773 1.44-2.267 3.651-2.062a.42.42 0 0 1 .376.49v.007a.415.415 0 0 1-.444.334c-1.752-.158-2.553 1.013-2.843 1.601a.412.412 0 0 1-.49.209zM7.59 39.364a.586.586 0 1 1-1.173 0 .586.586 0 0 1 1.172 0z",
    fill: "#999"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.339)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E2A324",
    y: 3.664,
    width: 39.724,
    height: 55.173,
    rx: 2.094
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6C760",
    y: 2.729,
    width: 39.724,
    height: 55.173,
    rx: 2.094
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.571 6.703h34.467v48.393H2.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.247 9.82H7.011a1.639 1.639 0 0 1-1.636-1.638V2.883c0-.902.734-1.637 1.636-1.637h25.236c.902 0 1.637.735 1.637 1.637v5.3c0 .902-.735 1.636-1.637 1.636zM7.011 2.182a.703.703 0 0 0-.702.702v5.299c0 .386.314.702.702.702h25.236a.703.703 0 0 0 .702-.702v-5.3a.703.703 0 0 0-.702-.701H7.011z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999",
    x: 8.295,
    y: 1.091,
    width: 22.783,
    height: 3.74,
    rx: 0.813
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#666",
    x: 8.295,
    width: 22.783,
    height: 2.961,
    rx: 0.813
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92CB4A",
    d: "M4.44 11.067h30.222v3.896H4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0F2",
    d: "M4.44 16.677h9.502v10.911H4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.982 20.028c0 1.077-.767 1.948-1.713 1.948-.946 0-1.713-.871-1.713-1.948s.767-1.948 1.713-1.948c.946 0 1.713.871 1.713 1.948zM13.942 27.743v-3.251c-1.047-1.051-2.75-1.737-4.673-1.737-2.022 0-3.8.756-4.829 1.901v3.087h9.502zM33.882 18.236H16.746a.625.625 0 0 1 0-1.248h17.136c.342 0 .624.28.624.624 0 .342-.28.624-.624.624zM33.882 20.574H16.746a.626.626 0 0 1-.624-.624c0-.342.28-.624.624-.624h17.136c.342 0 .624.28.624.624 0 .342-.28.624-.624.624zM29.21 22.911H16.746a.626.626 0 0 1-.623-.623c0-.343.28-.624.623-.624H29.21c.342 0 .624.28.624.624 0 .342-.28.623-.624.623zM33.882 25.249H16.746a.626.626 0 0 1-.624-.624c0-.342.28-.624.624-.624h17.136c.342 0 .624.28.624.624 0 .342-.28.624-.624.624z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1B7690",
    x: 4.284,
    y: 30.861,
    width: 30.222,
    height: 1.403,
    rx: 0.663
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21 27.588H16.746a.626.626 0 0 1-.623-.624c0-.342.28-.624.623-.624H29.21c.342 0 .624.28.624.624 0 .342-.28.624-.624.624zM25.412 44.464H5.082c-.289 0-.525-.264-.525-.586 0-.322.236-.587.524-.587h20.331c.289 0 .525.265.525.587 0 .322-.236.586-.525.586zM21.791 46.334H5.081c-.288 0-.524-.264-.524-.586 0-.322.236-.586.524-.586h16.71c.289 0 .525.264.525.586 0 .322-.236.586-.525.586zM25.412 48.206H5.082c-.289 0-.525-.264-.525-.586 0-.323.236-.587.524-.587h20.331c.289 0 .525.264.525.587 0 .322-.236.586-.525.586zM21.791 50.076H5.081c-.288 0-.524-.264-.524-.586 0-.323.236-.587.524-.587h16.71c.289 0 .525.264.525.587 0 .322-.236.586-.525.586zM25.412 51.948H5.082c-.289 0-.525-.264-.525-.587 0-.322.236-.586.524-.586h20.331c.289 0 .525.264.525.586 0 .323-.236.587-.525.587zM23.08 36.398h-7.018c-.223 0-.406-.264-.406-.587 0-.322.183-.586.406-.586h7.017c.223 0 .406.264.406.586 0 .323-.183.587-.406.587zM23.08 37.691h-7.018c-.223 0-.406-.264-.406-.586 0-.323.183-.587.406-.587h7.017c.223 0 .406.264.406.587 0 .322-.183.586-.406.586zM12.915 36.398H5.897c-.223 0-.405-.264-.405-.587 0-.322.182-.586.405-.586h7.018c.223 0 .405.264.405.586 0 .323-.182.587-.405.587zM12.915 37.691H5.897c-.223 0-.405-.264-.405-.586 0-.323.182-.587.405-.587h7.018c.223 0 .405.264.405.587 0 .322-.182.586-.405.586zM32.892 36.398h-7.017c-.223 0-.406-.264-.406-.587 0-.322.183-.586.406-.586h7.017c.223 0 .406.264.406.586 0 .323-.183.587-.406.587zM32.892 37.691h-7.017c-.223 0-.406-.264-.406-.586 0-.323.183-.587.406-.587h7.017c.223 0 .406.264.406.587 0 .322-.183.586-.406.586z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.497 12.986a2.257 2.257 0 1 1-4.514.001 2.257 2.257 0 0 1 4.514 0z",
    fill: "#6AA322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.318 12.533h-.545a.127.127 0 0 1-.127-.127v-.545a.127.127 0 0 0-.127-.128h-.684a.127.127 0 0 0-.127.128v.545c0 .07-.057.127-.127.127h-.546a.127.127 0 0 0-.127.127v.685c0 .07.057.127.127.127h.546c.07 0 .127.057.127.127v.545c0 .07.057.127.127.127h.684c.07 0 .127-.057.127-.127V13.6c0-.07.057-.127.127-.127h.545c.07 0 .127-.057.127-.127v-.685a.127.127 0 0 0-.127-.127z",
    fill: "#FFFFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.366 41.553H4.54V33.69h29.825v7.864zm-29.327-.5h28.827V34.19H5.04v6.864h-.002z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M14.238 33.822h1.172v7.482h-1.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C81E6",
    d: "M24.286 33.822h1.172v7.482h-1.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.44 1.914H10.106c-.225 0-.409-.264-.409-.586 0-.323.184-.587.409-.587H21.44c.224 0 .408.264.408.587 0 .322-.184.586-.408.586zM26.814 1.914h-3.388c-.225 0-.409-.264-.409-.586 0-.323.184-.587.409-.587h3.388c.225 0 .409.264.409.587 0 .322-.184.586-.409.586z",
    fill: "#EBF5FF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m29.014 35.92-.316.289c-1.552 1.417-3.746 2.228-6.023 2.228-2.276 0-4.25-.722-5.8-2.033l-.702-.593-.702.593c-1.552 1.311-3.613 2.033-5.801 2.033-2.189 0-4.47-.811-6.021-2.228l-.316-.289-1.555.02.026 1.096c.51 22.14 12.566 27.965 13.94 28.556l.512.19.452-.19c1.373-.591 13.43-6.416 13.94-28.556l.027-1.1-1.658-.019-.003.003z",
    fill: "#BADCE0",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.398 37.235c-1.676 1.416-3.971 2.29-6.503 2.29-2.662 0-5.06-.966-6.754-2.512h-.026c.495 21.516 12.07 27.06 13.283 27.582l.055.021.049-.02c1.213-.524 12.788-6.067 13.283-27.583h-.129c-1.693 1.546-4.093 2.514-6.755 2.514s-4.828-.875-6.503-2.29v-.002z",
    fill: "#92CB4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.001 38.64s-.402 1.758 2.862 1.105c0 0 .502 11.305 5.626 20.2 0 0-8.136-9.647-8.488-21.304v-.002z",
    fill: "#A6DF5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.091 38.74s-2.159 12.862 3.566 24.871c0 0 .421 4.73 2.56-3.316 2.14-8.046 4.32-19.949 4.32-19.949s-10.496-3.065-10.446-1.608v.002z",
    fill: "#7EB736"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 40.097s1.004 12.51-4.32 22.911c0 0 8.859-5.017 10.998-13.064 2.14-8.045 1.607-11.657 1.607-11.657s-8.336.352-8.285 1.808v.002z",
    fill: "#6AA322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m14.47 64.227-.367-.135c-.763-.328-3.473-1.675-6.244-5.31-3.629-4.759-5.871-11.36-6.666-19.617l-.104-1.083 1.052.274c.101.026.22.057.295.075H2.5l.143.058c2.617 1.087 3.768 1.522 5.979 1.35 2.025-.156 3.985-.879 5.244-1.935l.489-.41.488.41c1.48 1.242 3.551 1.983 5.537 1.983 2.433 0 4.463-.626 5.717-1.763l.221-.2.298.003h.24l.81-.003-.047.81C26.428 58.892 14.91 64.04 14.795 64.092l-.326.135zM2.834 40.213c.858 7.412 2.953 13.343 6.234 17.646 2.3 3.019 4.546 4.31 5.376 4.716.988-.51 3.352-2.113 5.619-5.154 3.33-4.47 5.322-10.3 5.933-17.347-1.477.868-3.418 1.338-5.616 1.338-2.198 0-4.334-.725-6.03-1.96-1.477 1.044-3.527 1.746-5.613 1.908-2.295.175-3.673-.238-5.903-1.144v-.003z",
    fill: "#447525"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m14.478 65.786-.512-.19C12.594 65.003.537 59.178.026 37.038L0 35.943l1.555-.02.316.289c1.551 1.416 3.746 2.228 6.02 2.228 2.275 0 4.25-.721 5.802-2.033l.702-.592.701.592c1.552 1.312 3.613 2.033 5.801 2.033 2.189 0 4.471-.812 6.023-2.228l.316-.288 1.657.02-.026 1.099c-.51 22.139-12.566 27.964-13.94 28.556l-.453.19.004-.003zM2.292 39.18c.474 7.777 2.511 14.108 6.064 18.844 2.523 3.364 5.067 4.88 6.094 5.395 1.018-.512 3.566-2.028 6.094-5.395 3.563-4.749 5.601-11.102 6.067-18.906-1.677.974-3.643 1.495-5.71 1.495-2.389 0-4.665-.707-6.503-2.005-1.838 1.298-4.115 2.005-6.503 2.005-2.022 0-3.948-.5-5.603-1.433z",
    fill: "#EBF5FF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#D9FFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.629 50.405a1.006 1.006 0 0 1-.643-1.244 39.96 39.96 0 0 0 1.21-5.374c.084-.541.582-.914 1.125-.842.558.074.946.594.86 1.151a42.188 42.188 0 0 1-1.272 5.65c-.163.54-.744.837-1.28.66zM23.542 55.29a1.006 1.006 0 0 1-.425-1.332c.14-.287.276-.578.41-.873a1.003 1.003 0 1 1 1.835.816c-.143.318-.29.63-.441.94-.253.513-.875.72-1.38.45zM5.95 58.249a27.93 27.93 0 0 1-.746-1.167 1.005 1.005 0 0 1 .374-1.394 1.006 1.006 0 0 1 1.35.363c.218.362.444.714.677 1.059.303.45.205 1.056-.231 1.378a1.002 1.002 0 0 1-1.425-.24zM2.626 51.656c-.838-2.301-1.473-4.812-1.897-7.488a1.003 1.003 0 1 1 1.983-.316c.403 2.55 1.007 4.934 1.8 7.115a1.004 1.004 0 0 1-1.887.69h.001z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.538 47.582h-2.457a.571.571 0 0 1-.571-.572v-2.458a.571.571 0 0 0-.572-.571h-3.085a.571.571 0 0 0-.572.571v2.458a.571.571 0 0 1-.571.572H9.253a.571.571 0 0 0-.572.572v3.087c0 .316.256.572.572.572h2.457c.316 0 .571.255.571.571v2.458c0 .316.256.572.572.572h3.085a.571.571 0 0 0 .572-.572v-2.458c0-.316.255-.571.571-.571h2.457a.571.571 0 0 0 .571-.572v-3.087a.571.571 0 0 0-.571-.572z",
    fill: "#FFF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.09 39.758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.484 19.983V5.733h-.931V20.61c0 2.028.63 3.911 1.704 5.465H8.43a7.772 7.772 0 0 1-2.945-6.09z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.386 20.609V5.733h-.904v14.25a7.777 7.777 0 0 0 2.946 6.091h.2a7.77 7.77 0 0 1-2.244-5.465h.002z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#999",
    transform: "rotate(-77.33 5.402 6.058)",
    cx: 5.402,
    cy: 6.058,
    rx: 4.522,
    ry: 4.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#666",
    transform: "rotate(-77.33 5.403 5.403)",
    cx: 5.403,
    cy: 5.403,
    rx: 4.522,
    ry: 4.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#999",
    transform: "rotate(-77.3 5.407 5.411)",
    cx: 5.407,
    cy: 5.411,
    rx: 2.215,
    ry: 2.214
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59 2.366a.586.586 0 1 1-1.173 0 .586.586 0 0 1 1.172 0zM2.081 4.225a.412.412 0 0 1-.25-.579c.392-.773 1.44-2.267 3.651-2.062a.42.42 0 0 1 .376.49v.007a.415.415 0 0 1-.444.334C3.662 2.257 2.86 3.428 2.57 4.016a.412.412 0 0 1-.49.209z",
    fill: "#999"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.914 10.574c-3.443-1.678-6.144 1.353-6.781 2.213-.637-.86-3.338-3.891-6.781-2.213-8.06 3.927-.497 13.659 6.78 18.374 7.132-4.621 14.936-14.4 6.782-18.374z",
    fill: "#C42028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.768 18.486c2.263-1.375 4.98-1.729 7.488-2.578 2.22-.752 4.477-2.142 5.347-4.25a7.855 7.855 0 0 0-1.689-1.084c-3.443-1.678-6.144 1.353-6.781 2.213-.637-.86-3.338-3.891-6.781-2.213-4.948 2.412-4.007 7.01-.86 11.293a9.447 9.447 0 0 1 3.273-3.38l.003-.001z",
    fill: "#E53839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.16 19.903 4.49-.68 1.096-1.827 1.566 3.813 1.723-6.791.94 5.172.887-1.567.627 1.515 5.638.365-5.9.26-.365-.627s-.992 2.56-.992 2.403c0-.156-1.096-3.918-1.096-3.918l-1.201 5.59-1.88-4.493-.47.887-5.063-.104v.002z",
    fill: "#AA0C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.008 19.676 4.49-.679 1.097-1.828 1.566 3.814 1.722-6.791.94 5.172.887-1.568.627 1.515 5.638.365-5.9.26-.365-.626s-.991 2.559-.991 2.402c0-.156-1.096-3.917-1.096-3.917l-1.202 5.589-1.878-4.493-.471.888-5.064-.104v.001z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.555 11.89c-.016.156.06.327.208.368 1.796.5 2.87 1.04 4 3.33 0 0-.478-2.631-3.742-3.991-.21-.088-.442.06-.466.293z",
    fill: "#FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.549 11.95a.586.586 0 1 0 1.171.002.586.586 0 0 0-1.171-.002z",
    fill: "#FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49 12.613c1.933 5.605-6.706 13.908-9.658 13.908-1.992 0-4.584-1.76-6.791-3.942 1.939 2.43 4.534 4.711 7.095 6.37 6.106-3.957 12.706-11.698 9.356-16.336h-.002z",
    fill: "#AA0C1B"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtHealthInsurance2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-health-insurance-2.0260ac60507015c6be5e144163cbca31.svg";